import React from 'react'
import me from "../images/Aditya_Boddepalli.jpg"
import aws_ccp from "../images/aws_ccp.png"
import aws_saa from "../images/aws_saa.png"
import aws_dva from "../images/aws_dva.png"
import Socials from './Socials'

function Home() {
    return (
        <div name="screen" className='w-full min-h-screen bg-gradient-to-b from-zinc-400 to-slate-300'>
            <div name="imgAndIntro" className='max-w-screen-xl mx-auto px-4 pt-32 pb-16 sm:pt-40 sm:pb-24 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12'>
                <div name="Img" className='w-full md:w-1/2 flex justify-center'>
                    <img 
                        src={me} 
                        alt='my pretty face' 
                        className='rounded-2xl w-3/4 md:w-full max-w-md object-cover shadow-lg transform hover:scale-105 transition-transform duration-300'
                    />
                </div>
                
                <div name="intro" className='w-full md:w-1/2 space-y-6'>
                    <div className='space-y-2'>
                        <h2 className='text-4xl md:text-6xl font-bold text-black tracking-tight'>
                            Welcome!
                        </h2>
                        <h2 className='text-3xl md:text-5xl font-bold text-violet-500 tracking-tight'>
                            I am Aditya Boddepalli
                        </h2>
                    </div>
                    
                    <p className='text-xl md:text-2xl text-black leading-relaxed'>
                        I'm a Software Engineer who is passionate about designing and building performant and efficient cloud-based solutions. My interests lie in <span className='text-bold text-sky-600'>Cloud Computing, Backend Systems, and Artificial Intelligence.</span> Feel free to reach out to me about new opportunities or just to chat!
                    </p>

                    <div className='flex flex-row gap-4 pt-4'>
                        <a 
                            rel="noreferrer" 
                            target='_blank' 
                            href='https://www.credly.com/badges/60739b5e-a7c1-4434-ac85-dba840c39db7/public_url'
                            className='transform hover:scale-110 transition-transform duration-300'
                        >
                            <img src={aws_dva} alt='aws dva badge' className='w-24 md:w-32 rounded-xl' />
                        </a>
                        <a 
                            rel="noreferrer" 
                            target='_blank' 
                            href='https://www.credly.com/badges/cacb76da-4ccb-4d68-ac37-216399232e72/public_url'
                            className='transform hover:scale-110 transition-transform duration-300'
                        >
                            <img src={aws_saa} alt='aws saa badge' className='w-24 md:w-32 rounded-xl' />
                        </a>
                        <a 
                            rel="noreferrer" 
                            target='_blank' 
                            href='https://www.credly.com/badges/cfc1b3ca-1f68-4a54-8b1e-e5224124f4bb/public_url'
                            className='transform hover:scale-110 transition-transform duration-300'
                        >
                            <img src={aws_ccp} alt='aws ccp badge' className='w-24 md:w-32 rounded-xl' />
                        </a>
                    </div>
                </div>

                <Socials />
            </div>
        </div>
    )
}

export default Home
